import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 24px', background: '#FAFBFA' }}>
      <div style={{ width: 64, height: 64, borderRadius: 16, background: '#85BB65', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24, boxShadow: '0 4px 20px rgba(133,187,101,0.3)' }}>
        <span style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: 28, color: '#fff' }}>K</span>
      </div>
      <h1 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 900, fontSize: 'clamp(60px, 12vw, 120px)', color: '#E8EBE8', lineHeight: 1, margin: '0 0 8px', letterSpacing: '-0.04em' }}>404</h1>
      <h2 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 22, color: '#1A1E1A', margin: '0 0 12px' }}>Page not found</h2>
      <p style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 15, color: '#8A948A', maxWidth: 360, lineHeight: 1.7, marginBottom: 36 }}>
        The page you're looking for doesn't exist. It may have moved or been removed.
      </p>
      <Link to="/" style={{ padding: '12px 28px', borderRadius: 9, background: '#85BB65', color: '#fff', fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 14, textDecoration: 'none', boxShadow: '0 4px 16px rgba(133,187,101,0.3)' }}>
        Back to Home
      </Link>
    </div>
  );
}
